import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Website } from '../types/Website';
import { getWebsiteLookupDataFromUrl } from '../utils/api/website.utils';

const PreviewPage: React.FC = () => {
  const [html, setHtml] = useState('');
  const [searchParams] = useSearchParams();
  const { websiteId, websiteState, websiteType } = getWebsiteLookupDataFromUrl(searchParams);

  useEffect(() => {
    if (websiteId !== null) {
      Website.fromId(websiteId).then(website => {
        setHtml(website.getHtml(websiteState));
      });
    }
  }, [websiteId, websiteState]);

  if (!websiteId || !websiteState || !websiteType) {
    return <div>No website id, state or type</div>;
  }

  return <div dangerouslySetInnerHTML={{ __html: html }} />;
};

export default PreviewPage;
